module.exports = __webpack_public_path__ + "static/media/green-tiger.19b34363.jpg";